// Place scripts that can be run at the bottom of the page here. Ideally this script will be run asynchronously.

const $ = window.jQuery; // We can use '$' instead of 'jQuery' :)

// SEARCH FORM
// call showSearchForm() when the user clicks the search icon
// setTimeout(showSearchForm, 1000);
showSearchForm();
function showSearchForm() {
  const searchIcon = document.querySelector('.search-toggle');
  searchIcon.addEventListener('click', function (ev) {
    ev.preventDefault();
    const searchForm = document.querySelector('.search-form');
    searchForm.classList.toggle('show');
  });
}

// MENU BEHAVIOR

// call hookMenuToggleToAuxiliaryMenu after 1 second
setTimeout(hookMenuToggleToAuxiliaryMenu, 1000);
function hookMenuToggleToAuxiliaryMenu() {
  // Add an event listener to the menu toggle button
  const menuToggle = document.querySelector('.menu-toggle');
  menuToggle.addEventListener('click', function (ev) {
    // use the same jQuery method used in Genesis' responsive-menu.js, line 249
    $('.nav-auxiliary').slideToggle('fast');
    $('.nav-primary').toggleClass('shown');
  });
}

// IMAGE LOADING

// Load background images after the page has loaded
loadAllBackgroundImages();
// Load background images after the window has resized
window.addEventListener('resize', function (ev) {
  loadAllBackgroundImages();
});

function loadAllBackgroundImages() {
  loadBackgroundImage(['entry-header', 'has-image']);
  loadBackgroundImage(['intro-wrap']);
  loadBackgroundImage(['infographic-1-wrap']);
}

function loadBackgroundImage(classes = null) {
  // if classes is not an array, return
  if (!Array.isArray(classes)) return;
  const selector = '.' + classes.join('.');
  const el = document.querySelector(selector); // only look for one
  if (!el) return;
  console.log('loadBackgroundImages is using ', selector);
  console.log(el);
  // get the image url from the data-bkgurl attribute
  const bkgUrl = el.dataset.bkgurl;
  const originalStyle = el.style.cssText;
  // get properties from the old style as a stri
  el.setAttribute('style', originalStyle + 'background-image: url(' + bkgUrl + ')');
}
// Lazy load images in picture elements with class="lazy"; adapted from: https://stackoverflow.com/questions/29806353/lazyloading-picture-elements
document.addEventListener("DOMContentLoaded", function (event) {
  const lazyImages1 = [].slice.call(
    document.querySelectorAll(".lazy > source")
  );
  const lazyImages2 = [].slice.call(
    document.querySelectorAll("img.lazy")
  );

  if ("IntersectionObserver" in window) {
    let lazyImageObserver =
      new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.srcset = lazyImage.dataset.srcset;
            let nextSib = lazyImage.nextElementSibling;
            // if nextSib is an img, set its src to the data-srcset attribute
            if (nextSib.tagName === 'IMG') {
              nextSib.src = nextSib.dataset.srcset;
            }
            // TODO: allow the next element to fade in
            //  lazyImage.nextElementSibling.classList.add('fade-in');
            lazyImage.parentElement.classList.remove("lazy");
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

    lazyImages1.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
    lazyImages2.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Not supported, load all images immediately
    lazyImages1.forEach(function (image) {
      image.nextElementSibling.src = image.nextElementSibling.dataset.srcset;
    });
    lazyImages2.forEach(function (image) {
      image.nextElementSibling.src = image.nextElementSibling.dataset.srcset;
    });
  }
});




// main menu dropdown 
$('#menu-main > .menu-item > a').hover(function () {
  // remove from all elements 
  $('.menu-item a, .sub-menu-toggle, .sub-menu').removeClass('hover');
  $(this).addClass('hover').siblings().addClass('hover');
  $(this).siblings('.sub-menu').find('li:first').addClass('hover');
});
$('.sub-menu > li').hover(function () {
  $('.sub-menu .menu-item').removeClass('hover');
  $(this).addClass('hover');
});

// Removing target="_blank" from sidebar 
$('.parent-sidebar-menu a[target="_blank"]').removeAttr('target');

// homepage fade in modules 
$(document).ready(function(){
  if ($('.homepage').length) {
    $('.program-areas, .project-snapshots, .focus-areas, .infographic-1').addClass('fade-in-module');
    $(window).scroll(function () {
      $('.fade-in-module').each(function () {
        var top_of_element = $(this).offset().top;
        var bottom_of_element = $(this).offset().top + $(this).outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();
        if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !$(this).hasClass('is-visible')) {
          $(this).addClass('is-visible');
        }
      });
    });
  }
});